import { config } from "../config"

export function getExtention(id) {
    if (id >= config.broadcast.mp3_id) {
        return `.mp3`
    }
    return `.mp4`
}